import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withExpandedListItem } from '../../../hoc';
import styles from './ExpandedListItem.module.scss';
import { ExpandedListItemProps, ExpandedListItemState } from './ExpandedListItemModel';


class ExpandedListItem extends Component<ExpandedListItemProps, ExpandedListItemState> {
    transitionTimeout: number | null = null;

    state = {
        startTransition: false
    };

    componentDidMount() {
        this.transitionTimeout = window.setTimeout(
            () => {
                this.setState({ startTransition: true });
            },
            100);
    }

    componentWillUnmount() {
        if (this.transitionTimeout) {
            window.clearTimeout(this.transitionTimeout);
        }
    }

    render() {
        const { renderExpandedItem, style, parent, } = this.props;
        const { startTransition } = this.state;
        const listContainerNode = parent;

        return (
            ReactDOM.createPortal(
                <div
                    style={style}
                    className={`${styles.ExpandedListItem} ${startTransition ? styles.ExpandedListItemTransition : ''}`}
                >
                    {renderExpandedItem()}
                </div>,
                listContainerNode
            )
        );
    }
}

export default withExpandedListItem(ExpandedListItem);
